<template>
	<div class="skyInput">
		<el-input
			:style="{ width: width }"
			@blur="$emit('blur')"
			v-bind="$attrs"
			:clearable="clearable"
			type="text"
			v-model="inputValue"
			:disabled="filterOptions()"
			@input="input"
			:placeholder="placeholder"
		>
			<template v-slot:append v-if="unit">{{ unit }}</template>
		</el-input>
		<!-- <el-tooltip placement="top">
			<div slot="content">
				<span v-for="(v, id) in tips" :key="id">{{v}}<br/></span>
			</div>
			<i class="el-icon-question" v-show="tips&&tips.length"></i>
		</el-tooltip> -->
	</div>
</template>
<script>
export default {
	name: 'skyInput',
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: [String, Number],
			default: ''
		},
		unit: {
			type: String,
			default: ''
		},
		// tips: {
		// 	type: Array,
		// 	default: () => []
		// },
		clearable: {
			type: Boolean,
			default: true
		},
		filterOptions: {
			type: Function,
			default: () => false
		},
		width: {
			type: String,
			default: '100%'
		}
	},
	data() {
		return {
			inputValue: this.value
		};
	},
	methods: {
		input(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		}
	},
	watch: {
		value: {
			handler(val) {
				this.inputValue = val;
			},
			immediate: true
		}
	}
};
</script>
